import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { InfoBlock, InfoBlockTypes } from '@gem/ui-kit';
import { getMascotImageSrc } from '@gem/utils';

import styles from './EmptyContentStub.styles.m.css';

export const EmptyContentStub: FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <InfoBlock
        descriptions={[t('profile_media_no_attachments')]}
        type={InfoBlockTypes.Sidebar}
        image={getMascotImageSrc(PROJECT_CONFIG.imageAssets.sharedData)}
      />
    </div>
  );
};
